 import api from '../seller-apis/api';

export async function unregisterDeviceToken() {
  try {
    const token = localStorage.getItem('fcmToken');

    if (token) {
      try {
        await api.auth.unregisterDeviceToken({ token });
      } catch (err) {
        console.warn('Backend unregisterDeviceToken failed', err);
      }
      localStorage.removeItem('fcmToken');
    }

    try {
      if (window && window?.firebase && window?.firebase?.messaging) {
        const messaging = window.firebase.messaging();
        if (messaging && messaging.deleteToken) {
          await messaging.deleteToken();
        }
      }
    } catch (err) {
      console.warn('firebase deleteToken attempt failed', err);
    }
  } catch (err) {
    console.warn('unregisterDeviceToken error', err);
  }
}
